import React from 'react';

const Divider = () => {
  return (
    <div className="flex items-center justify-center my-14 opacity-90">
      <div className="h-px bg-gradient-to-r from-transparent via-padua-border to-transparent w-32 sm:w-48"></div>
      <div className="mx-4 text-padua-gold flex items-center">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" fill="currentColor"/>
          <circle cx="12" cy="12" r="2" fill="#FFF9EF"/>
        </svg>
      </div>
      <div className="h-px bg-gradient-to-r from-transparent via-padua-border to-transparent w-32 sm:w-48"></div>
    </div>
  );
};

export default Divider;